import React, { useState } from "react";
import PropertyInquiryModal from "./PropertyInquiryModal";

const PropertyContactButton = ({ user, property }) => {
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsInquiryModalOpen(true)}
        className="inline-flex items-center justify-center text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-[#BEAF87] text-[#444444] border border-[#444444] hover:bg-[#C99A2E] h-10 px-4 py-2">
        Contact Agent
      </button>

      <PropertyInquiryModal
        isOpen={isInquiryModalOpen}
        onClose={() => setIsInquiryModalOpen(false)}
        user={user}
        property={property}
      />
    </>
  );
};

export default PropertyContactButton;
